/**
 * 成长值变更列表
 * v1.0.1 http://wiki.nidianwo.com/pages/viewpage.action?pageId=18713388 zhangtong
 */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react'
// import Header from './../../components/header'
import Runtime from 'utils/runtime'

export default class ErrorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    Runtime.exportApis.setHeader({ title: '页面加载错误' })
  }

  handleLeftClick = () => {
    Runtime.exportApis.closeWindow()
  }

  render() {
    return (
      <h1 style={{ textAlign: 'center' }} className="container">
        {this.props.location.query.errorMessage ? decodeURIComponent(this.props.location.query.errorMessage) : '页面加载错误'}
      </h1>
    )
  }
}
